export default __webpack_public_path__ + "static/media/trash.82807076.svg";